import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
// import CallToActionTwo from '../container/CallToAction/CallToActionTwo';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Upload = () => {
  return (
    <React.Fragment>
      <SEO title="Upload camera-ready paper | DMBD 2025" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Upload camera-ready paper"
        content="Registration"
        contentTwo="Upload camera-ready paper"
        linkage="/registration"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content2">
          <br />
          <h3 className="note">
            Instructions for Preparing Camera-Ready Copy and Uploading your
            Final Materials
          </h3>
          <br />
          <br />
          <div className="ins-lncs">
            <h5>
              Instructions for Preparing Camera-Ready Copy and Uploading your Final Materials
            </h5>
            <p className="crucial">
              It is crucial for you to follow the following 5 steps!
            </p>
            <ul>
              <li>
                <span className="step">Step 1:</span> Revise your paper
                carefully according to the comments of the reviewers as soon as
                possible. You may view the reviewers&apos; ratings, comments,
                and/or suggestions about the paper in your author&apos;s account
                of the Online Submission System at EasyChair. Please improve
                your writing as possible as you can, and proofread your final
                paper by a English native speaker.
              </li>
              <li><span className="step">Step 2:</span> Prepare your paper in the exact format as the sample paper for CCIS. Failure to do so may result in the exclusion of your paper from the CCIS proceedings
                Please  read the authors&apos; instructions carefully before preparing your papers.
                The sample paper and author instructions for LaTeX users can be found at <a className="simple-link" href="./files/latex_template.zip">latex_template.zip</a>,
                or you can view it on <a className="simple-link" href="https://www.overleaf.com/latex/templates/springer-lecture-notes-in-computer-science/kzwwpvhwnvfj#.WuA4JS5uZpi">Overleaf</a>.
                For MS word users,  please download <a className="simple-link" href="./files/word_template.zip">word_template.zip</a>.
                If you need more help on preparing your paper, please visit <a className='simple-link'
                  href="https://www.springer.com/cn/computer-science/lncs/conference-proceedings-guidelines"
                  target="_blank"
                  rel="noopener noreferrer">Information for Authors of Computer Science Publications</a>. 
                  Each paper must not exceed 20 pages including figures and references (papers beyond Twelve (12) pages are subject to page surcharges) and must not less than 10 pages.
                   Your final paper MUST be submitted by <span className="STYLE3">&apos;December 10, 2025&apos;</span>. All papers must be re-submitted even if the reviewers indicated that no change is required</li>
              <li>
                <span className="step">Step 3:</span> Adding ORCID Identifier.{" "}
                We encourage all contributing authors to apply for an individual ORCID at <a className="simple-link" href="https://www.orcid.org">www.orcid.org</a>  and
                include them with your address information. (where ORCID (Open Researcher and Contributor ID) hosts a registry of unique researcher identifiers and a transparent
                method of linking research activities to these identifiers)

              </li>
              <li>
                <span className="step">Step 4:</span> Fill out the{" "}
                <a
                  className="simple-link"
                  href="./files/Springer Proceedings LTP_SN Singapore-dmbd2025.docx"
                >
                  Springer-Nature Copyright-Form
                </a>{" "}
                and sign it by all authors or one representative.{" "}
              </li>
              <li>
                <span className="step">Step 5:</span> Submit your final
                materials (source files, pdf, copyright form) via{" "}
                <a
                  className="simple-link"
                  href="https://www.easychair.org/conferences/?conf=dmbd2025"
                >
                  Online Submission System
                </a>{" "}
                through your Easychair account for making Springer CCIS proceedings.<br></br>
                <br></br>
                <div className="lm">Instructions for submit final materials:</div>
                <br></br>
                <ol>
                  <li>
                    Final source files (LaTeX or MS-Word)
                    <ul>
                      <li>
                        For LaTeX users, please submit LaTeX files for the text
                        and PS/EPS or PDF/JPG files for all figures; any further
                        style files and fonts you have used together with your
                        source files and that are not generally available at
                        CTAN;
                        <ul>
                          <li>
                            Final DVI file (for papers prepared using
                            LaTeX/TeX);
                          </li>
                          <li>Final PDF file (for reference);</li>
                          <li>
                            Put these files in one folder named as latex files.
                          </li>
                        </ul>
                      </li>
                      <li>
                        For Microsoft Word users, please submit final word file
                        directly.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Scanned the signed{" "}
                    <a
                      className="simple-link"
                      href="./files/Springer Proceedings LTP_SN Singapore-dmbd2025.docx"
                    >
                      Springer-Nature Copyright-Form
                    </a>
                  </li>
                  <li>
                    Login as a proceeding author by clicking{" "}
                    <span className="STYLE3">&apos;proceeding&apos;</span> menu
                    in{" "}
                    <a className="simple-link" href="https://www.easychair.org/conferences/?conf=dmbd2025">
                      your Easychair account
                    </a>
                  </li>
                  <li>
                    By clicking &apos;<span className="STYLE3">paper no.</span>{" "}
                    &apos; menu in your account, you can see the detailed
                    information of your paper for proceeding.
                  </li>
                  <li>Click hyperlink &apos;Update authors&apos; at the   right-upper corner to update your authors&apos; information, and click hyperlink &apos;Upload new version&apos; at the   right-upper corner to upload final revised paper and signed copyright-form for your each accepted paper. <br />
                  </li>
                </ol>
              </li>
            </ul>
          </div>
          <br></br>
          <br></br>
          <br></br>
          <div className="ins-journals">
            <h5>
              Instructions for papers selected for special issues of SCI/EI-indexed journals
            </h5>
            <p className="crucial">Please contact the Guest Editor(s) who announced the acceptance result to you for instructions.</p>
          </div>
          <br></br>
          <br></br>
          <div className="back-reg">
            <Link
              className="btn btn-primary btn-hover-secondary  mt-s"
              to={process.env.PUBLIC_URL + "/registration"}
            >
              Back to Registration page
            </Link>
          </div>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Upload;
